export default {
  title: 'אמנת שירות',
  content: `
    <p>
      פולאריס סוכנות לביטוח פנסיוני (2018) בע"מ (להלן: "הסוכנות") – מתחייבת לפעול על פי התפיסה הממקמת את הלקוח במרכז. זאת, לטובת כל לקוחותינו, בהתאם לאמנת שירות הלקוחות ובהתאם לחזון וערכי היסוד של הסוכנות.
    </p>

    <p>
      <h3>הגינות וכיבוד הפרטיות</h3>
      הלקוח זכאי לפרטיות ועל כן אנו מתחייבים לשמור על סודיות השיחות עם ועל רשומותיו בהתאם להוראות הדין.
      פעילותינו עבור לקוחותינו נעשית באופן הגון ומכבד המתייחס לזמנו של הלקוח בהתאם.
    </p>

    <p>
      <h3>זמינות ויעילות במתן מענה אישי לכל לקוח</h3>
      אנו מעמידים לרשות הלקוח, מגוון אמצעי
      התקשרות עמנו; דואר אלקטרוני, אתר אינטרנט, פקס, דואר ומענה טלפוני אנושי ואישי.
    </p>

    <p>
      <h3>שעות קבלת קהל ומועדי שירות לקוחות בסוכנות הם:</h3>
      שנקר 3, הרצליה פיתוח
      <br/>
      שעות קבלת קהל בתיאום מראש בימים: א'-ה'
      <br/>
      בשעות:  09:00-17:00
      <br/>
      יום ו' סגור
    </p>

    <p>
      <h3>דרכים ליצירת קשר:</h3>
      טלפון: 050-7683557
      <br/>
      דוא"ל: service@polaris-fin.co.il
      <br/>
      אתר אינטרנט: www.polaris-fin.co.il
    </p>

    <p>
      <strong>אנחנו כאן בשביל הלקוח.</strong>
    </p>

    <p>
      הסוכנות תיתן מענה מתאים לצרכי הלקוח,
      ובתוך שבעה ימי עסקים ממועד פניית לקוח בבקשה לתיאום פגישה איתו או בבקשה לקבלת מסמכים.
      <br/>
      הסוכנות תקיים תקשורת יעילה וזמינה עם לקוחותיה, תספק מענה ראשוני לכל פנייה
      ותמסור תשובות ברורות ומנומקות ככל הניתן, וזאת תוך שני ימי עסקים מקבלת פניית הלקוח.
      <br/>
      הסוכנות תיתן מענה ענייני תוך זמן סביר לבקשת לפניית לקוח בנושא תביעה, וזאת מבלי
      לגרוע מהוראות כל דין לעניין זה. כמו כן, הסוכנות, תמסור ללקוח שפנה אליה בעניין
      תביעה, מידע אודות זכויותיו, ואת דרכי הפעולה העומדות בפניו בהליך יישוב התביעה.
    </p>

    <p>
      <h3>שקיפות ופשטות</h3>
      אנו שואפים לייצר חוויה קלה ונעימה ללקוח. לדבר עם הלקוח בשפה ברורה ומובנת, לשקף ולפשט את
      השלבים הנדרשים לביצוע בקשותיו וללוות אותו בבירוקרטיה הנדרש, מול חברות הביטוח.
    </p>

    <p>
      <h3>מקצועיות</h3>
      הביטוח הינו אחד מאמצעי הפחתת הסיכון והבטחת העתיד החשובים והמשמעותיים של הלקוח.
      אנו מבטיחים להעמיד לרשות הלקוח את טובי העובדים, המומחים והוותיקים בתחום,
      אשר עוברים הכשרות מקצועיות ככל הנדרש. בכל פניה של הלקוח אלינו
      אנו מתחייבים לתת מענה מתאים לצרכיו לפי העדפותיו האישיות של כל לקוח.
    </p>
  `,
};
